/* eslint-disable import/no-webpack-loader-syntax */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../store';

import styles from './Logo.module.scss';

interface IProps {
    auth: boolean;
    getBetterAuth: () => void;
}
const Logo: React.FC<IProps> = ({ getBetterAuth, auth }) => {
    useEffect(() => {
        getBetterAuth();
    }, [getBetterAuth]);

    return (
        <img
            className={styles.logo}
            src={
                auth
                    ? require(`!url-loader?limit=true!../../assets/logo_better.webp`)
                    : require('!url-loader?limit=true!../../assets/logo.webp')
            }
            onClick={() => window.location.reload()}
        />
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        auth: state.shellHeader.auth,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getBetterAuth: () => {
        dispatch({ type: 'shellHeader/getBetterAuth' });
    },
});
export default connect(mapStateToProps, mapDispatchToProps)(Logo);
